import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { removeData, ApproveData ,Inactivedata} from '../reduxactions/adminactions/ADoctorlistActions';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { RootState } from '../reducers';
import { useNavigate } from 'react-router-dom';



export const AdminDoctor = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')

    const dispatch = useDispatch();

    const [doctor, setDoctor] = useState<[]>([]);
    const getdata = async () => {
        try {
            const payload = { q: 1 };
            const apiname = Admin_API.Doc_API;
            const data = await LoginService.getData(apiname, payload);
            setDoctor(data);
        } catch (error) {

        }
    };

    useEffectOnce(() => {
        getdata()

    }, []);
    const remove = useSelector((state: RootState) => state.adoctor.remove);
    const toast = useRef(remove);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const [removedata, setRemoveData] = useState({
        DoctorID: '',
    });
    const Removeduring = (rowData: any) => {
        setRemoveData({
            DoctorID: rowData.DoctorID,
        });
        setDeleteConfirmation(true);
    }
    const confirmDelete = async () => {
        const { DoctorID } = removedata;

        await dispatch(removeData(DoctorID) as any);
        toast.current.show({ severity: 'error', summary: 'Doctor deleted Successfully', life: 3000 });
        setDeleteConfirmation(false);
        getdata()
    };


    const cancelDelete = () => {
        setDeleteConfirmation(false);
        setApproveConfirmation(false)
    }
    const [approveConfirmation, setApproveConfirmation] = useState(false);

    const [docdata, setDocdata] = useState({
        DoctorID: '',
    });
    const Approveduring = (rowData: any) => {
        setDocdata({
            DoctorID: rowData.DoctorID,
        });
        setApproveConfirmation(true);
    }

    const DocApprove = async () => {
        const { DoctorID } = docdata;

        await dispatch(ApproveData(DoctorID) as any);
        toast.current.show({ severity: 'success', summary: 'Doctor Accepts Successfully.', life: 3000 });
        setApproveConfirmation(false);
        getdata()
    };

    const [inacitveConfirmation, setInacviteConfirmation] = useState(false);

    const [inaciveata, setInaciveata] = useState({
        DoctorID: '',
    });
    const Inacivteduring = (rowData: any) => {
        setInaciveata({
            DoctorID: rowData.DoctorID,
        });
        setInacviteConfirmation(true);
    }

    const DocInactive = async () => {
        const { DoctorID } = inaciveata;

        await dispatch(Inactivedata(DoctorID) as any);
        toast.current.show({ severity: 'error', summary: 'Doctor Inactivated Successfully..', life: 3000 });
        setInacviteConfirmation(false);
        getdata()
    };
    const navigate = useNavigate();
    const viewPage = (rowData: any) => {
      const url = `/viewdoctor/${rowData.DoctorID}`;
      console.log('rowdata:', rowData.DoctorID)
      navigate(url);
    }
    //for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/admindoctor.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };
    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{marginLeft:'100px'}}>
           <section className="content-header">
             <div className="container-fluid">
               <div className="grid mb-2">
                 <div className="col-6">
                 </div>
               </div>
             </div>
           </section>
           <section className="content" style={{marginLeft:'110px'}} >
             <div className="row">
               <div className="col-md-12">
                 <div className="card-header p-2" style={{ marginTop: '50px' }}>
                   <h2>Doctor List</h2>
                 </div>
                 <div className="col-16" style={{ textAlign:"right"}}>
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
                 <br></br>
                 <div className="box box-primary">
                   <div className="card">
                     <p className="m-0">
                       <div>
                         <div className="card flex flex-wrap justify-content">
                           <span className="p-input-icon-left">
                             <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                             <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                           </span>
   
                         </div>
                         <DataTable value={doctor} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['FullName', 'Email','SpecilityName','Status']} >
                                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                        <Column field="FullName" sortable header="Doctor Name"></Column>
                                                        <Column field="Email" sortable header="Email-ID"></Column>
                                                        <Column field="SpecilityName" sortable header="Speciality"></Column>
                                                        <Column header="Status" sortable body={(rowData) => rowData.Status ? rowData.Status.charAt(0).toUpperCase() + rowData.Status.slice(1).toLowerCase() : ''}
                                                        />
                                                        <Column header="Operation" body={(rowData) => (
                                                            <>
                                                                <Button
                                                                    className='mr-1'
                                                                    tooltip="View"
                                                                    severity="info"
                                                                    icon="pi pi-eye"
                                                                    rounded
                                                                    outlined
                                                                    onClick={() => viewPage(rowData)}

                                                                />
                                                                {/* Conditionally render buttons based on status */}
                                                                {['REGISTERED', 'WAITING FOR ACCEPTANCE', 'APPLIED'].includes(rowData.Status) && (
                                                                    <Button
                                                                        icon="pi pi-trash"
                                                                        tooltip="Delete"
                                                                        rounded
                                                                        outlined
                                                                        className="p-button-danger mr-1"
                                                                        style={{ backgroundColor: 'white', color: 'red' }}
                                                                        onClick={() => Removeduring(rowData)}

                                                                    />
                                                                )}
                                                                {['APPROVED', 'ACTIVE'].includes(rowData.Status) && (
                                                                    <Button
                                                                        icon="pi pi-times"
                                                                        tooltip="In-Active"
                                                                        rounded
                                                                        outlined
                                                                        className="p-button-warning mr-1"
                                                                        onClick={() => Inacivteduring(rowData)}

                                                                    />
                                                                )}
                                                                {rowData.Status === 'INACTIVE' && (
                                                                    <Button
                                                                        icon="pi pi-check-circle"
                                                                        tooltip="Approve"
                                                                        rounded
                                                                        outlined
                                                                        className="p-button-success mr-1"
                                                                        onClick={() => Approveduring(rowData)} 

                                                                    />

                                                                )}
                                                            </>

                                                        )} />
                                                    </DataTable>
   
                       </div>
                     </p>
                   </div>
                 </div>
               </div>
             </div>
           </section>
         </div>
            < Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                <div>Are you really want to Remove...?</div>
                <br></br>
                <Button label="Delete" icon="pi pi-check" className='mr-3 p-button-raised' onClick={confirmDelete} />
                <Button label="Close" icon="pi pi-times" onClick={cancelDelete} className="mr-3 p-button-secondary" />
            </Dialog >
            < Dialog header="" style={{ width: '30vw' }} visible={approveConfirmation} onHide={() => setApproveConfirmation(false)}>
                <div>Do you really want to Approve this Doctor</div>
                <br></br>
                <Button label="Approve" icon="pi pi-check" className='mr-3 p-button-raised' onClick={DocApprove} />
                <Button label="Close" icon="pi pi-times" onClick={cancelDelete} className="mr-3 p-button-secondary" />
            </Dialog >
            < Dialog header="" style={{ width: '30vw' }} visible={inacitveConfirmation} onHide={() => setInacviteConfirmation(false)}>
                <div>Do you really want to In-Active this doctor </div>
                <br></br>
                <Button label="In-Active" icon="pi pi-check" className='mr-3 p-button-raised' onClick={DocInactive} />
                <Button label="Close" icon="pi pi-times" onClick={cancelDelete} className="mr-3 p-button-secondary" />
            </Dialog >





            <Toast ref={toast} >
                <Message severity="success" content={remove} />
            </Toast>



        </div>
        )
}
